import React from 'react'

import * as S from './Message.styles'
import { MessageProps } from './Message.types'

const ErrorMessage = ({ className, message, absolute }: MessageProps): JSX.Element => (
  <S.ErrorMessage className={className} absolute={absolute}>
    {message}
  </S.ErrorMessage>
)

const SuccessMessage = ({ className, message, absolute }: MessageProps): JSX.Element => (
  <S.SuccessMessage className={className} absolute={absolute}>
    {message}
  </S.SuccessMessage>
)

export { ErrorMessage, SuccessMessage }
